import type React from "react";
import { useEffect } from "react";

import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import { BaseButton } from "shared/atoms/BaseButton";
import { Notification } from "shared/atoms/Notification";
import { useDevice } from "utils/hooks";
import { removeStorageValue } from "utils/storage";

import { LoginContainer } from "../components/LoginContainer";
import { LoginInfoContainer } from "../components/LoginInfoContainer";
import { Container, LoginWrapper } from "../components/styledComponents";
import { getSignedOutParams } from "../utils/getSignedOutParams";

export const Bankid: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { signedOutError } = getSignedOutParams(location);

  const { isMobileOrTablet } = useDevice();

  const onSignIn = () => {
    const url = isMobileOrTablet ? "open-mobile-app" : "scan-qr";
    navigate({ pathname: url, search: location.search });
  };

  useEffect(() => {
    // Cleanup to remove stored personal numbers
    // TODO: Remove this and the key after a while
    removeStorageValue("login-remember-pn");
  }, []);

  return (
    <LoginWrapper>
      <LoginContainer>
        <LoginInfoContainer title={t("login.bankid.title")} />

        <Container>
          <BaseButton
            type="submit"
            text={t("bankid.start_new")}
            onClick={onSignIn}
            icon="bankid"
            fullWidth
            iconPlacement="end"
          />

          {signedOutError && (
            <Notification variant="danger" style={{ marginTop: "30px" }}>
              {signedOutError === "session_expired" ? t("errors.session_expired") : signedOutError}
            </Notification>
          )}
        </Container>
      </LoginContainer>
    </LoginWrapper>
  );
};
